module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/schedule.json
// module id = 330
// module chunks = 235319718215566